import React, { useState, useEffect } from "react";
import vcdms from "../../../assets/rcc-version-logo.png";
import "../versions/version.css";
import packageVersion from "../../../../package.json";
import httpService from "../../../services/http.service";
import ErrorMessage from "../../common/errorMsg";
import { useHistory } from "react-router-dom";
import { decryptText, parseDecryptedText } from "../../authentication/encryptanddecrypted/encryptAndDecrypt";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Link } from "react-router-dom";
import { faQuestionCircle, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Version = () => {
  const history = useHistory();
  const [backendVersion, setbackendVersion] = useState("");
  const [property, setProperty] = useState({ NoOfProperty: "", UsedProperty: "", startDate: "", enddate: "" })

  useEffect(() => {
    async function fetchData() {
      let returndata = await httpService.get("getbackendversion").then(
        (res) => res.data
      )
        .catch((err) => {
          if (err && err.response && err.response.status === 401) {
            ErrorMessage("Session expired, please login again")
          }
          return
        });
      let dataUserPost = { userID: localStorage.getItem("UserId") };
      let LicenceInfo = localStorage.getItem("Licence")
      console.log(LicenceInfo, "decrypt")
      const Licence = parseDecryptedText(decryptText(LicenceInfo, dataUserPost.userID))
      console.log(Licence, "parseDecryptedText")

      let license = await httpService.CreateUpdate('getclouduserlicenses', dataUserPost).then(res => res.data)
      setProperty({ NoOfProperty: Licence.licenceNo, UsedProperty: license.UsedProperty, startDate: Licence.startDate, enddate: Licence.endDate })
      setbackendVersion(returndata);
    }
    fetchData();
  }, []);

  useEffect(() => {
    const customerID = localStorage.getItem("customerId");
    const type = localStorage.getItem("CloudUserType");
    if (customerID === 'Admin' || type === "admin") {
      history.push("/admindashboard");
    }
  }, [])

  return (
    <div>
      <div className="pad-15" style={{ margin: "20px" }}>
        <div className="form-boxdiv">
          {/* <div className="form-boxtopline5">About
            <button className="btn btn-primary" onClick={() => { history.push("/clouddashboard") }}>Go Back</button>
          </div> */}
          <div className="row form-boxtopline5">
            <div className="col-9" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <div
                onClick={() => {
                  history.push("/clouddashboard");
                }}
              >
                <Button className="back-btn"><i class="fa fa-chevron-left" aria-hidden="true"></i></Button>
              </div>
              <b>About {"  "} </b>


            </div>
          </div>


          <div className="form-boxtopcont">
            <div className="form-boxdiv-gray">
              <div className="form-boxtopcont user-form">
                <div className=" panel-default">
                  <div className="panel-body">
                    <div className="row">
                      <div className="col-sm-2">
                        <figure className="rcc-version-logo">
                          <img src={vcdms} alt="rsd cloud portal img" />
                        </figure>
                        <div className="rcc-version">
                          <h5 style={{ fontSize: "15px" }}>Radiant Stream Director Customer Portal </h5>
                          <h5 style={{ fontSize: "15px" }}>UI/UX Version :- <span>{packageVersion.version}</span></h5>
                          <h5 style={{ fontSize: "15px" }}>Backend Version :- <span>{backendVersion}</span></h5>
                          <h5 style={{ fontSize: "14px" }}>No. of Licensed Property :- <span>{property.UsedProperty}/{property.NoOfProperty}</span></h5>
                          <h5 style={{ fontSize: "14px" }}>Start Date :- <span>{property.startDate}</span></h5>
                          <h5 style={{ fontSize: "14px" }}>End Date :- <span>{property.enddate}</span></h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="helpQuestion">
          <Link to="/faq">
            <FontAwesomeIcon
              icon={faQuestionCircle}
              className="iconHelp"
              color="primary"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Version;
